import { onBeforeRouteLeave, type RouteLocationNormalized, type NavigationGuardNext } from '#vue-router'
import { tryOnMounted } from '@vueuse/core'

export function useGroupReservationChecker() {
  const nuxtApp = useNuxtApp()
  const confirmLeaveGroup = ref(false)
  const hasGroupOrder = computed(() => nuxtApp.$store.state.groupOrderStatus)

  tryOnMounted(() => {
    if (!hasGroupOrder.value) {
      return
    }
    checkGroupOrder(nuxtApp.$store.state.groupOrder)
  })

  function onBeforeRouteLeaveFn(to: RouteLocationNormalized, from: RouteLocationNormalized) {
    if (confirmLeaveGroup.value || to.query.group_code || !nuxtApp.$store.state.groupOrderStatus) {
      return true
    }
    // will show root dialog (modal)
    checkGroupOrderRouteLeave(to, from)
    return false
  }

  function checkGroupOrderRouteLeave(to: RouteLocationNormalized, _from: RouteLocationNormalized) {
    const groupGuardDialogData = {
      status: true,
      options: {
        useCloseIcon: true,
        showCancelBtn: false,
        header: nuxtApp.$i18n.t('group_order_leaving_modal_title', { name: nuxtApp.$store.state.groupOrder?.nickname || '' }),
        message: nuxtApp.$i18n.t('group_order_leaving_modal_context'),
        icon: 'sad-1.svg',
        customConfirmBtnText: nuxtApp.$i18n.t('group_order_leaving_modal_confirm_action'),
        confirm: () => {
          confirmLeaveGroup.value = true
          nuxtApp.$router.push(to)
        },
        close: () => {
          confirmLeaveGroup.value = false
        },
      },
    }
    nuxtApp.$store.dispatch('dialog/setRootMessageOption', groupGuardDialogData)
  }

  function checkGroupOrder(groupOrder: any = {}) {
    const isExpired = nuxtApp.$dayjs(groupOrder.booking_time).isBefore(nuxtApp.$dayjs())
    if (!isExpired || !groupOrder.booking_time) {
      return
    }

    const groupExpiredDialogData = {
      status: true,
      options: {
        useCloseIcon: true,
        showCancelBtn: false,
        header: nuxtApp.$i18n.t('group_order_expired_modal_title', { name: groupOrder?.nickname || '' }),
        message: nuxtApp.$i18n.t('group_order_expired_modal_context', {
          name: groupOrder?.nickname || '',
          datetime: timeUtil.formatDateTime(groupOrder.booking_time),
        }),
        icon: 'sad-1.svg',
        customConfirmBtnText: nuxtApp.$i18n.t('group_order_expired_modal_others_action'),
        confirm: () => {
          confirmLeaveGroup.value = true
          const bid = nuxtApp.$store.state.product.productInfo.bid
          nuxtApp.$router.push(nuxtApp.$localePath(`/branches/${bid}`))
        },
        close: () => {
          confirmLeaveGroup.value = false
        },
      },
    }
    nuxtApp.$store.dispatch('dialog/setRootMessageOption', groupExpiredDialogData)
  }

  return {
    confirmLeaveGroup,
    onBeforeRouteLeaveFn,
  }
}
